var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKyt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 8C8.44772 8 8 8.44772 8 9V23C8 23.5523 8.44772 24 9 24H23C23.5523 24 24 23.5523 24 23V18C24 17.4477 24.4477 17 25 17C25.5523 17 26 17.4477 26 18V23C26 24.6569 24.6569 26 23 26H9C7.34315 26 6 24.6569 6 23V9C6 7.34315 7.34315 6 9 6H14C14.5523 6 15 6.44772 15 7C15 7.55228 14.5523 8 14 8H9Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7071 6.29296C25.8946 6.4805 26 6.73485 26 7.00007L26 13.0001C26 13.5524 25.5522 14.0001 25 14.0001C24.4477 14.0001 24 13.5524 24 13.0001V9.45036L16.6169 16.9891C16.2305 17.3837 15.5974 17.3903 15.2028 17.0039C14.8082 16.6174 14.8016 15.9843 15.188 15.5897L22.6209 8.0001L19 8.00014C18.4477 8.00015 18 7.55244 18 7.00015C18 6.44787 18.4477 6.00015 18.9999 6.00014L24.9999 6.00007C25.2652 6.00007 25.5195 6.10542 25.7071 6.29296Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyt);
export default __webpack_public_path__ + "static/media/KYT.e8ae4175c8a547174cba833c9d156ec7.svg";
export { ForwardRef as ReactComponent };